import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, errMsg, setToken } from "../lib/api";
import { inputCls, Field } from "./ui";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0A0A0A] px-4 font-sans">
      <form onSubmit={submit} className="glass-card w-full max-w-sm p-8" data-testid="admin-login-form">
        <div className="mb-6 grid h-12 w-12 place-items-center rounded-full border border-[#D4AF37]/50 text-[#D4AF37]"><Lock size={20} /></div>
        <h1 className="font-serif text-2xl font-bold text-white">Admin <span className="gold-text">Login</span></h1>
        <p className="mt-1 text-sm text-zinc-500">DaddyAnna247 control panel</p>
        <div className="mt-8 space-y-4">
          <Field label="Email"><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email" /></Field>
          <Field label="Password"><input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password" /></Field>
        </div>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="btn-gold mt-6 w-full justify-center" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign In"}</button>
      </form>
    </div>
  );
}
